export const motorConstants = {
  SET_PACKAGE: 'SET_PACKAGE'
};
